exports = module.exports = require("../loader/justep-css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./loader/justep-css-loader?{"url":true,"import":false,"sourceMap":false,"modules":false,"minimize":true}!/usr/local/x5/tools/uix-web/~/postcss-loader!./pages/app.css
// module id = ./loader/justep-css-loader/index.js?{"url":true,"import":false,"sourceMap":false,"modules":false,"minimize":true}!../../../../tools/uix-web/node_modules/postcss-loader/index.js!./pages/app.css
// module chunks = 22